function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PrintStream from '../../../../java/io/PrintStream';
import StringReader from '../../../../java/io/StringReader';
import DecimalFormat from '../../../../java/text/DecimalFormat';
import System from '../../../../java/lang/System';
import ArrayList from '../../../../java/util/ArrayList';
import ByteArrayOutputStream from '../../../../java/io/ByteArrayOutputStream';
import Assert from './Assert';
import IOException from '../../../../java/io/IOException';
import LineNumberReader from '../../../../java/io/LineNumberReader';
var StringUtil = /*#__PURE__*/function () {
  function StringUtil() {
    _classCallCheck(this, StringUtil);
    StringUtil.constructor_.apply(this, arguments);
  }
  return _createClass(StringUtil, [{
    key: "getClass",
    value: function getClass() {
      return StringUtil;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "chars",
    value: function chars(c, n) {
      var ch = new Array(n).fill(null);
      for (var i = 0; i < n; i++) {
        ch[i] = c;
      }
      return new String(ch);
    }
  }, {
    key: "getStackTrace",
    value: function getStackTrace() {
      if (arguments.length === 1) {
        var t = arguments[0];
        var os = new ByteArrayOutputStream();
        var ps = new PrintStream(os);
        t.printStackTrace(ps);
        return os.toString();
      } else if (arguments.length === 2) {
        var _t = arguments[0];
        var depth = arguments[1];
        var stackTrace = '';
        var stringReader = new StringReader(StringUtil.getStackTrace(_t));
        var lineNumberReader = new LineNumberReader(stringReader);
        for (var i = 0; i < depth; i++) {
          try {
            stackTrace += lineNumberReader.readLine() + StringUtil.NEWLINE;
          } catch (e) {
            if (e instanceof IOException) {
              Assert.shouldNeverReachHere();
            } else throw e;
          } finally {}
        }
        return stackTrace;
      }
    }
  }, {
    key: "split",
    value: function split(s, separator) {
      var separatorlen = separator.length;
      var tokenList = new ArrayList();
      var tmpString = '' + s;
      var pos = tmpString.indexOf(separator);
      while (pos >= 0) {
        var token = tmpString.substring(0, pos);
        tokenList.add(token);
        tmpString = tmpString.substring(pos + separatorlen);
        pos = tmpString.indexOf(separator);
      }
      if (tmpString.length > 0) tokenList.add(tmpString);
      var res = new Array(tokenList.size()).fill(null);
      for (var i = 0; i < res.length; i++) {
        res[i] = tokenList.get(i);
      }
      return res;
    }
  }, {
    key: "toString",
    value: function toString() {
      if (arguments.length === 1 && typeof arguments[0] === 'number') {
        var d = arguments[0];
        return StringUtil.SIMPLE_ORDINATE_FORMAT.format(d);
      }
    }
  }, {
    key: "spaces",
    value: function spaces(n) {
      return StringUtil.chars(' ', n);
    }
  }]);
}();
export { StringUtil as default };
StringUtil.constructor_ = function () {};
StringUtil.NEWLINE = System.getProperty('line.separator');
StringUtil.SIMPLE_ORDINATE_FORMAT = new DecimalFormat('0.#');